export const home = "/sobre-a-caixa-seguradora";
